import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {user} from '../../../store/reducers/user';
import Formatter from '../../../util/formatter';
import React, {Fragment} from 'react';
import moment from 'moment/moment';
import {Button} from '@mui/material';
import config from '../../../app/config';
import MessageBox from '../../../util/messageBox';
import makeStyles from '@mui/styles/makeStyles';
import useOpenState from '../../../hooks/useOpenState';
import * as PropTypes from 'prop-types';

const useButtonStyles = makeStyles((theme) => ({
    checkButton: {
        height: '100%',
        width: '100%',
        color: theme.palette.mode === 'light' ? '#000' : '#fff',
        borderColor: theme.palette.inPatient.accordionBorder,
    },
    selectedButton: {
        height: '100%',
        width: '100%',
        background: '#93c47d',
        color: '#000',
        fontSize: 'small',
        borderColor: '#6aa84f',
        '&:hover': {
            background: '#6aa84f',
            borderColor: '#6aa84f',
        },
        '&:disabled': {
            color: 'grey',
        },
    },
}));

const CheckButton = (props) => {
    const classesButton = useButtonStyles();
    const {t} = useTranslation();

    const {data, name} = props;

    // User
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const [isConfirmClearOpen, openConfirmClear, closeConfirmClear] = useOpenState(false, true);

    const completeHandler = () => {
        const data = {
            by: tester,
            date: moment().toISOString(),
            check: true,
        };
        props.onClick({name: name, value: data});
    };

    const clearComplete = () => {
        const data = {
            by: '',
            date: null,
            check: false,
        };
        props.onClick({name: name, value: data});
        closeConfirmClear();
    };

    const renderButton = () => {
        if (data.check) {
            return (
                <Button
                    disabled={props.disabled}
                    className={classesButton.selectedButton}
                    onClick={openConfirmClear}
                    variant="outlined"
                >
                    {t('COMPLETED by ')}
                    {data.by} <br/>
                    {t('at ')}
                    {moment(data.date).format(config.defaultDateTimeFormat)}
                </Button>
            );
        } else {
            return (
                <Button
                    disabled={props.disabled}
                    onClick={completeHandler}
                    className={classesButton.checkButton}
                    variant="outlined"
                >
                    {t('Check Complete')}
                </Button>
            );
        }
    };

    return (
        <>
            <MessageBox
                open={isConfirmClearOpen}
                onClose={closeConfirmClear}
                title={t('Confirmation')}
                message={t('Are you sure you want to clear this entry?')}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={clearComplete}
            />

            {renderButton()}
        </>
    );
};

CheckButton.propTypes = {
    data: PropTypes.shape({date: PropTypes.any, by: PropTypes.string, check: PropTypes.bool}),
    onClick: PropTypes.func,
    name: PropTypes.string,
    disabled: PropTypes.bool,
};

export default CheckButton;